<template>
  <div class="maincont" id="setting_demand">
    <div class="ef--inner">
      <div id="monthly_threshold">

        <h2>月別閾値設定</h2>

        <p class="subttl">
          <span style="margin-right:10px;">
            <label>年度</label>
          </span>

          <span class="select-box">
            <select v-model="settingDate">
              <option
                v-for="(item, index) in settingYearList"
                v-bind:value="item.value"
                v-bind:key="index"
              >{{ item.text }}</option>
            </select>
          </span>

          <span style="margin-left:68%;" v-if="info.commonSetting.air_conditioner_control == true">
            <input
             type="button"
             id="manual_control"
             class="manualControl"
             value="空調自動制御(手動) -設定-"
             v-bind:disabled="info.commonSetting.air_conditioner_devices == false"
             v-bind:style="info.commonSetting.air_conditioner_devices == false ? 'background:#91A1AF; border:#91A1AF' : ''"
             @click="showManualControlDialog = true"
             v-if="info.commonSetting.manual_control_reserved == false"
           />
            <input
             type="button"
             id="manual_control"
             class="manualControl"
             value="空調自動制御(手動) -解除-"
             v-bind:disabled="info.commonSetting.air_conditioner_devices == false"
             v-bind:style="info.commonSetting.air_conditioner_devices == false ? 'background:#91A1AF; border:#91A1AF' : ''"
             @click="showManualControlDialog = true"
             v-else
           />
          </span>
        </p>

        <div class="form" method="post" action>
          <div id="setting_demand_form">
            <div class="common-setting">
              <!------------------------------------------------------------------
              <-- 空調機制御無し
              <------------------------------------------------------------------>
              <table v-if="info.commonSetting.air_conditioner_control == false || info.commonSetting.air_conditioner_devices == false">
                <thead>
                  <tr>
                    <th style="width:150px; text-align:center;">注意閾値</th>
                    <th style="width:150px; text-align:center;">警報閾値</th>
                    <th style="width:150px; text-align:center;">デマンド目標値</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="text-align:center;">{{ info.commonSetting.caution_threshold }} kW</td>
                    <td style="text-align:center;">{{ info.commonSetting.alarm_threshold }} kW</td>
                    <td style="text-align:center;">{{ info.commonSetting.contract_power }} kW</td>
                  </tr>
                </tbody>
              </table>

              <!------------------------------------------------------------------
              <-- 空調機制御有り
              <------------------------------------------------------------------>
              <table v-else>
                <thead>
                  <tr>
                    <th style="width:150px; text-align:center;">注意電力閾値</th>
                    <th style="width:150px; text-align:center;">警報電力閾値</th>
                    <th style="width:150px; text-align:center;">デマンド目標値</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style="text-align:center;">{{ info.commonSetting.caution_power }} kW</td>
                    <td style="text-align:center;">{{ info.commonSetting.limit_power }} kW</td>
                    <td style="text-align:center;">{{ info.commonSetting.contract_power }} kW</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="monthly-setting">
              <!------------------------------------------------------------------
              <-- 空調機制御無し
              <------------------------------------------------------------------>
              <table v-if="info.commonSetting.air_conditioner_control == false || info.commonSetting.air_conditioner_devices == false">
                <thead>
                  <tr>
                    <th style="width:140px; text-align:center;">月</th>
                    <th style="width:280px; text-align:center;">注意閾値</th>
                    <th style="width:280px; text-align:center;">警報閾値</th>
                    <th style="width:240px; text-align:center;">デマンド目標値</th>
                    <th style="width:180px; text-align:center;">昨年デマンド実績</th>
                    <th style="width:180px; text-align:center;">今年度デマンド実績</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in info.monthlySettings" v-bind:key="index">
                    <td style="text-align:center;">{{ getMonth(item.date) }}</td>
                    <td>
                      <input
                        type="text"
                        :name="'caution_threshold_'+index"
                        data-vv-as="注意閾値"
                        v-model="item.caution_threshold"
                        v-validate="(item.alarm_threshold == '' && item.contract_power == '') ? 'numeric|min_value:0|max_value:9999' : 'required|numeric|min_value:0|max_value:9999'"
                        v-bind:disabled="item.modify == false"
                        v-bind:style="item.modify == false ? 'background-color:gainsboro' : ''"
                      > kW &nbsp;&nbsp; {{ getThresholdPercent(item.contract_power, item.caution_threshold) }}
                      <div class="err_message" style="font-size:10px;">
                        {{ errors.first("caution_threshold_"+index) }}
                      </div>
                    </td>
                    <td>
                      <input
                        type="text"
                        :name="'alarm_threshold_'+index"
                        data-vv-as="警報閾値"
                        v-model="item.alarm_threshold"
                        v-validate="(item.caution_threshold == '' && item.contract_power == '') ? 'numeric|min_value:0|max_value:9999|comp_alarm_threshold:'+item.caution_threshold : 'required|numeric|min_value:0|max_value:9999|comp_alarm_threshold:'+item.caution_threshold"
                        v-bind:disabled="item.modify == false"
                        v-bind:style="item.modify == false ? 'background-color:gainsboro' : ''"
                      > kW &nbsp;&nbsp; {{ getThresholdPercent(item.contract_power, item.alarm_threshold) }}
                      <div class="err_message" style="font-size:10px;">
                        {{ errors.first("alarm_threshold_"+index) }}
                      </div>
                    </td>
                    <td>
                      <input
                        type="text"
                        :name="'contract_power_'+index"
                        data-vv-as="デマンド目標値"
                        v-model="item.contract_power"
                        v-validate="(item.caution_threshold == '' && item.alarm_threshold == '') ? 'numeric|min_value:0|max_value:9999' : 'required|numeric|min_value:0|max_value:9999'"
                        v-bind:disabled="item.modify == false"
                        v-bind:style="item.modify == false ? 'background-color:gainsboro' : ''"
                      > kW
                      <div class="err_message" style="font-size:10px;">
                        {{ errors.first("contract_power_"+index) }}
                      </div>
                    </td>
                    <td style="text-align:right; padding-right:40px;">
                      {{ getMeasurePower(item.measure_power_last_year) }}
                    </td>
                    <td style="text-align:right; padding-right:40px;">
                      {{ getMeasurePower(item.measure_power_this_year) }}
                    </td>
                  </tr>
                </tbody>
              </table>

              <!------------------------------------------------------------------
              <-- 空調機制御有り
              <------------------------------------------------------------------>
              <table v-else>
                <thead>
                  <tr>
                    <th style="width:140px; text-align:center;">月</th>
                    <th style="width:280px; text-align:center;">注意電力閾値</th>
                    <th style="width:280px; text-align:center;">限界電力閾値</th>
                    <th style="width:240px; text-align:center;">デマンド目標値</th>
                    <th style="width:180px; text-align:center;">昨年デマンド実績</th>
                    <th style="width:180px; text-align:center;">今年度デマンド実績</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in info.monthlySettings" v-bind:key="index">
                    <td style="text-align:center;">{{ getMonth(item.date) }}</td>
                    <td>
                      <input
                        type="text"
                        :name="'caution_power_'+index"
                        data-vv-as="注意電力閾値"
                        v-model="item.caution_power"
                        v-validate="(item.limit_power == '' && item.target_power == '') ? 'numeric|min_value:0|max_value:9999' : 'required|numeric|min_value:0|max_value:9999'"
                        v-bind:disabled="item.modify == false"
                        v-bind:style="item.modify == false ? 'background-color:gainsboro' : ''"
                      > kW &nbsp;&nbsp; {{ getThresholdPercent(item.target_power, item.caution_power) }}
                      <div class="err_message" style="font-size:10px;">
                        {{ errors.first("caution_power_"+index) }}
                      </div>
                    </td>
                    <td>
                      <input
                        type="text"
                        :name="'limit_power_'+index"
                        data-vv-as="警報電力閾値"
                        v-model="item.limit_power"
                        v-validate="(item.caution_power == '' && item.target_power == '') ? 'numeric|min_value:1|max_value:9999|comp_limit_power:'+item.caution_power : 'required|numeric|min_value:1|max_value:9999|comp_limit_power:'+item.caution_power"
                        v-bind:disabled="item.modify == false"
                        v-bind:style="item.modify == false ? 'background-color:gainsboro' : ''"
                      > kW &nbsp;&nbsp; {{ getThresholdPercent(item.target_power, item.limit_power) }}
                      <div class="err_message" style="font-size:10px;">
                        {{ errors.first("limit_power_"+index) }}
                      </div>
                    </td>
                    <td>
                      <input
                        type="text"
                        :name="'target_power_'+index"
                        data-vv-as="デマンド目標値"
                        v-model="item.target_power"
                        v-validate="(item.caution_power == '' && item.limit_power == '') ? 'numeric|min_value:0|max_value:9999' : 'required|numeric|min_value:0|max_value:9999'"
                        v-bind:disabled="item.modify == false"
                        v-bind:style="item.modify == false ? 'background-color:gainsboro' : ''"
                      > kW
                      <div class="err_message" style="font-size:10px;">
                        {{ errors.first("target_power_"+index) }}
                      </div>
                    </td>
                    <td style="text-align:right; padding-right:40px;">
                      {{ getMeasurePower(item.measure_power_last_year) }}
                    </td>
                    <td style="text-align:right; padding-right:40px;">
                      {{ getMeasurePower(item.measure_power_this_year) }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <!----------------------------------------------------------------->

            </div>

            <div id="submit_area">
               <input
                 type="button"
                 id="submit"
                 class="submit"
                 value="登録"
                 @click="onSubmmit"
               />
               <input
                 type="button"
                 id="cancel"
                 class="cancel"
                 value="キャンセル"
                 @click="$router.go(-1)"
               />
            </div>

          </div>
        </div>
      </div>
    </div>
    <ManualControlDialog
      @close="showManualControlDialog = false"
      v-if="showManualControlDialog"
      :account="(typeof this.$route.params.id === 'undefined') ? this.$store.state.childID : this.$route.params.id"
      :loginID="(typeof this.$route.params.id === 'undefined') ? this.$store.state.childID : this.$store.state.loginID"
      :reserved="this.info.commonSetting.manual_control_reserved"
    ></ManualControlDialog>
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import ManualControlDialog from "../components/ManualControlDialog";

export default {
  name: "SettingDemand",

  components: {
    ManualControlDialog
  },

  data: function() {
    return {
      showManualControlDialog: false,
      settingDate: "",
      settingYearList: [],
      info: {
        commonSetting: {},
        monthlySettings: []
      }
    };
  },

  watch: {
    settingDate: function(newValue, oldValue) {
      this.getMonthlyData(newValue);
    }
  },
  computed: {
    getMonth: function() {
      return function(date) {
        let ret = moment(date, 'YYYY-MM').year() + "年" + (moment(date, 'YYYY-MM').month() + 1) + "月";
        return ret;
      }
    },
    getRequiredValidate: function() {
      return function(param1, param2, index) {
        let ret = false;
        if (((param1 == null) || (param1 == "")) && ((param2 == null) || (param2 == ""))) {
          ret = true;
        }
        return ret;
      }
    },
    getThresholdPercent: function() {
      return function(contractPower, threshold, index) {
        let ret = "";
        if ((isNaN(parseInt(contractPower)) == false) && (isNaN(parseInt(threshold)) == false)) {
          if (isNaN(Math.floor(threshold / contractPower * 100)) == false) {
            ret = "( " + Math.floor(threshold / contractPower * 100) + " % )";
          }
        }
        return ret;
      }
    },
    getMeasurePower: function() {
      return function(measurePower) {
        let ret = "";
        if ((measurePower != null) && (measurePower != "")) {
          ret = measurePower + " kW";
        }
        return ret;
      }
    }
  },

  methods: {
    setValidate: function() {
      let caution_threshold_validate = {
        required: () => '必須項目です',
        numeric: () => '入力範囲は 0 ～ 9999 です',
        min_value: () => '入力範囲は 0 ～ 9999 です',
        max_value: () => '入力範囲は 0 ～ 9999 です'
      };
      let alarm_threshold_validate = {
        required: () => '必須項目です',
        numeric: () => '入力範囲は 0 ～ 9999 です',
        min_value: () => '入力範囲は 0 ～ 9999 です',
        max_value: () => '入力範囲は 0 ～ 9999 です'
      };
      let contract_power_validate = {
        required: () => '必須項目です',
        numeric: () => '入力範囲は 0 ～ 9999 です',
        min_value: () => '入力範囲は 0 ～ 9999 です',
        max_value: () => '入力範囲は 0 ～ 9999 です'
      };
      let caution_power_validate = {
        required: () => '必須項目です',
        numeric: () => '入力範囲は 0 ～ 9999 です',
        min_value: () => '入力範囲は 0 ～ 9999です',
        max_value: () => '入力範囲は 0 ～ 9999です'
      };
      let limit_power_validate = {
        required: () => '必須項目です',
        numeric: () => '入力範囲は 1 ～ 9999 です',
        min_value: () => '入力範囲は 1 ～ 9999 です',
        max_value: () => '入力範囲は 1 ～ 9999 です'
      };
      let target_power_validate = {
        required: () => '必須項目です',
        numeric: () => '入力範囲は 0 ～ 9999 です',
        min_value: () => '入力範囲は 0 ～ 9999 です',
        max_value: () => '入力範囲は 0 ～ 9999 です'
      };

      let dict = { custom: {} };
      for (let i = 0; i < 12; i++) {
        dict.custom["caution_threshold_" + i] = caution_threshold_validate;
        dict.custom["alarm_threshold_" + i] = alarm_threshold_validate;
        dict.custom["contract_power_" + i] = contract_power_validate;
        dict.custom["caution_power_" + i] = caution_power_validate;
        dict.custom["limit_power_" + i] = limit_power_validate;
        dict.custom["target_power_" + i] = target_power_validate;
      }
      this.$validator.localize('ja', dict);

      this.$validator.extend(
        "comp_alarm_threshold",
        {
          params: ['caution_threshold'],
          getMessage: field => `注意閾値以上の値のみ入力可能です`,
          validate (alarm_threshold, [caution_threshold]) {
            if (parseInt(caution_threshold) > parseInt(alarm_threshold)) {
              return false;
            }
            return true;
          }
        },
        { hasTarget: true }
      );

      this.$validator.extend(
        "comp_limit_power",
        {
          params: ['caution_power'],
          getMessage: field => `注意電力閾値より大きい値のみ入力可能です`,
          validate (limit_power, [caution_power]) {
            if (parseInt(caution_power) >= parseInt(limit_power)) {
              return false;
            }
            return true;
          }
        },
        { hasTarget: true }
      );
    },

    getSettingYearList: function(yearList) {
      let ret = [];
      for (let i = 0; i < yearList.length; i++) {
        ret.push({
          value: yearList[i] + "/04/01",
          text: yearList[i] + "年"
        });
      }
      return ret;
    },

    getMonthlyData: function(date) {
      let childID = this.$route.params.id;
      if (!this.$route.params.id) {
        childID = this.$store.state.childID;
      }
      this.$axios
        .post(
          `/srv/api/monthly_threshold/${childID}`,
          { date: date },
          { withCredentials: true }
        )
        .then(response => {
          if (typeof response.data == "object") {
            if (response.data.status == "failure") {
              console.warn("Response failure");
            } else {
              this.info.monthlySettings = response.data.monthlySettings;
              for (let i = 0; i < 12; i++) {
                if (this.info.monthlySettings[i].contract_power == null) {
                  this.info.monthlySettings[i].contract_power = '';
                }
                if (this.info.monthlySettings[i].alarm_threshold == null) {
                  this.info.monthlySettings[i].alarm_threshold = '';
                }
                if (this.info.monthlySettings[i].caution_threshold == null) {
                  this.info.monthlySettings[i].caution_threshold = '';
                }
                if (this.info.monthlySettings[i].target_power == null) {
                  this.info.monthlySettings[i].target_power = '';
                }
                if (this.info.monthlySettings[i].limit_power == null) {
                  this.info.monthlySettings[i].limit_power = '';
                }
                if (this.info.monthlySettings[i].caution_power == null) {
                  this.info.monthlySettings[i].caution_power = '';
                }
              }
            }
          } else {
            alert("sesssion time out");
            this.$store.dispatch("logout");
            this.$router.push("/login");
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    onSubmmit: function() {
      let childID = this.$route.params.id;
      if (!this.$route.params.id) {
        childID = this.$store.state.childID;
      }
      const ans = confirm('登録しますか？');
      if (ans) {
        this.$validator.validateAll().then(result => {
          if (result) {
            let param = {
              monthlySettings: this.info.monthlySettings
            };
            this.$axios
              .put(`/srv/api/monthly_threshold/${childID}`, param, {
                withCredentials: true
              })
              .then(response => {
                console.log(response.data);
                const data = response.data;
                if (data.status !== undefined) {
                  if (data.status === "success") {
                    this.$router.go(-1);
                  } else {
                    console.log("error");
                    alert("登録できませんでした");
                  }
                } else {
                  console.log("error");
                  alert("登録できませんでした");
                }
              })
              .catch(error => {
                console.log(error);
              });
          }
        });
      }
    }
  },

  mounted: function() {
    console.log(`mounted= %o`, this.$route.params.id);
    let childID = this.$route.params.id;
    if (!this.$route.params.id) {
      childID = this.$store.state.childID;
    }
    this.setValidate();

    this.$axios
      .get(`/srv/api/monthly_threshold/${childID}`, {
        withCredentials: true,
      })
      .then((response) => {
        if (typeof response.data == "object") {
          this.info.commonSetting = response.data.commonSetting;
          this.settingYearList = this.getSettingYearList(response.data.commonSetting.year_list);
          this.settingDate = this.settingYearList[1].value;
        } else {
          alert("sesssion time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
};
</script>
